export default () => ({
  files: [],
  file: null,
  thumbs: []
})



// WEBPACK FOOTER //
// ./src/store/modules/files/state.js